(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'MultiplatformSettings-multiplatform-settings'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'MultiplatformSettings-multiplatform-settings'.");
    }
    globalThis['MultiplatformSettings-multiplatform-settings'] = factory(typeof globalThis['MultiplatformSettings-multiplatform-settings'] === 'undefined' ? {} : globalThis['MultiplatformSettings-multiplatform-settings'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var VOID = kotlin_kotlin.$_$.d;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(StorageSettings, 'StorageSettings', StorageSettings);
  //endregion
  function StorageSettings(delegate) {
    var tmp;
    if (delegate === VOID) {
      // Inline function 'com.russhwolf.settings.localStorage' call
      tmp = localStorage;
    } else {
      tmp = delegate;
    }
    delegate = tmp;
    this.vvt_1 = delegate;
  }
  protoOf(StorageSettings).jsq = function (key) {
    return this.vvt_1.removeItem(key);
  };
  protoOf(StorageSettings).wvt = function (key, value) {
    // Inline function 'com.russhwolf.settings.set' call
    this.vvt_1.setItem(key, value);
  };
  protoOf(StorageSettings).xvt = function (key) {
    // Inline function 'com.russhwolf.settings.get' call
    return this.vvt_1.getItem(key);
  };
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = StorageSettings;
  //endregion
  return _;
}));

//# sourceMappingURL=MultiplatformSettings-multiplatform-settings.js.map
